import script from "./lampadd.vue?vue&type=script&setup=true&lang=js"
export * from "./lampadd.vue?vue&type=script&setup=true&lang=js"

import "./lampadd.vue?vue&type=style&index=0&id=3bd63464&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd63464"]])

export default __exports__